import { ReducerAction, ReducerState } from './types'

function getDefaultReducerState({
  email,
}: Partial<ReducerState> = {}): ReducerState {
  return {
    email: email || '',
    error: '',
    loading: false,
    password: '',
  }
}

function reducer(state: ReducerState, action: ReducerAction): ReducerState {
  switch (action.type) {
    case 'SET_EMAIL': {
      return {
        ...state,
        email: action.email,
        loading: false,
      }
    }

    case 'SET_ERROR': {
      return {
        ...state,
        error: action.error,
        loading: false,
      }
    }

    case 'SET_LOADING_STATE': {
      return {
        ...state,
        loading: action.loading,
      }
    }

    case 'SET_PASSWORD': {
      return {
        ...state,
        loading: false,
        password: action.password,
      }
    }

    default: {
      return state
    }
  }
}

export { getDefaultReducerState, reducer }
